import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { getLandingPages } from "../../../../services/LandingPages/getLandingPages";
import { Skeleton } from "primereact/skeleton";
import PublishTemplateButton from "./Templates/Components/PublishTemplateButton";
import { useTemplateContext } from "./Templates/Context/TemplateContext";
import { getNameServers } from "../../../../services/LandingPages/getNameServers";
import { useForm } from "react-hook-form";
import { api } from "../../../../utils/api";

const TemplateList = ({ enterprise_id }) => {
  const navigate = useNavigate();
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [dominio, setDominio] = useState("");
  const [publishMessage, setPublishMessage] = useState("");
  const [publishLoading, setPublishLoading] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    defaultValues: {
      domain: "",
      subdomain: "",
    },
  });

  const [subdomain, domain] = watch(["subdomain", "domain"]);

  const {
    data: nsData,
    isLoading: nsLoading,
    error: nsError,
  } = useQuery(
    ["nameservers", enterprise_id],
    () => getNameServers(enterprise_id),
    {
      enabled: !!enterprise_id,
    }
  );

  useEffect(() => {
    if (nsData) {
      reset((prev) => ({
        ...prev,
        subdomain: nsData?.host?.Name?.replace(/\.$/, "").substring(4) || "",
        domain: nsData?.landingPageSignature?.domain || "",
      }));
    }
  }, [nsData, reset]);

  // console.log("Subdomínio:", watch("subdomain"));
  const fullUrl = domain ? `http://${domain}` : `http://${subdomain}`;

  const {
    cards,
    visible,
    setCards,
    cardState,
    pixClient,
    pixDataQR,
    setVisible,
    setPixDataQR,
    handleSubmitPayment,
    baseDataForm,
    paymentMethod,
    loadingButton,
    activeIndexModal,
    handleInputFocus,
    setPaymentMethod,
    creditCardClient,
    visiblePixPayment,
    handleInputChange,
    optionsInstallments,
    setActiveIndexModal,
    setCreditCardClient,
    setVisiblePixPayment,
    visiblePaymentMethods,
    visibleModalCreditCard,
    setVisiblePaymentMethods,
    setVisibleModalCreditCard,
  } = useTemplateContext();

  const { data: templates, isLoading: loadingTemplates } = useQuery({
    queryKey: ["landingPages"],
    queryFn: () => getLandingPages(enterprise_id),
  });

  const handlePublish = async (template, templateId) => {
    setPublishMessage("");
    setPublishLoading(true);
    try {
      const token = localStorage.getItem("@walletLoteToken");
      if (!token) {
        setPublishMessage("Você não está autenticado. Faça login novamente.");
        setPublishLoading(false);
        return;
      }

      const payload = {
        template_id: parseInt(templateId),
        // domain: "teste.com.br",
        enterprise_id: parseInt(enterprise_id),
      };

      await api.post("/landingPage/config", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setPublishMessage("Publicado com sucesso!");
      setSelectedTemplate(templateId); // Marca como selecionado após publicar
    } catch (err) {
      if (err.response?.status === 401) {
        setPublishMessage("Não autorizado. Faça login novamente.");
      } else {
        setPublishMessage("Erro ao publicar. Tente novamente.");
      }
    } finally {
      setPublishLoading(false);
    }
  };

  return (
    <div className="row">
      {loadingTemplates
        ? Array.from({ length: 3 }).map((_, idx) => (
            <div key={idx} className="col-xl-3 col-md-6 col-sm-12 mb-4">
              <Skeleton width="100%" height="325px" borderRadius="12px" />
            </div>
          ))
        : templates &&
          Object.entries(templates).map(([key, template]) => {
            let displayName = template.name;
            if (template.name === "Template 1")
              displayName = "Template Classic";
            if (template.name === "Template 2") displayName = "Template Modern";
            if (template.name === "Template 3")
              displayName = "Template Minimalist";
            const isComingSoon = ["Template Modern", "Template Minimalist"].includes(displayName);
            return (
              <div key={key} className="col-xl-4 col-sm-12 mb-4 hover-card">
                <Card
                  className="w-100 h-100 bg-cover bg-center relative flex flex-col px-1 py-0 text-white"
                  style={{
                    backgroundImage: `url(${template.img})`,
                    backgroundColor: "#41ae5d",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    height: "100%",
                    minHeight: 400,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    opacity: isComingSoon ? 0.5 : 1,
                  }}
                >
                  <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                  <div className="relative z-10 flex items-center gap-x-4 w-full">
                    <h2 className="text-lg font-bold whitespace-nowrap">
                      {displayName}
                    </h2>
                  </div>
                  <div className="relative z-10 flex mt-4 mb-0 gap-6 justify-content-center">
                    {isComingSoon ? (
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontFamily: "Axiforma, sans-serif",
                          fontSize: 28,
                          color: "#fff",
                          background: "rgba(0,0,0,0.4)",
                          borderRadius: 150,
                          padding: "12px 0"
                        }}
                      >
                        EM BREVE
                      </div>
                    ) : template.signatures?.some((sig) => sig.status !== 0) ? (
                      <>
                        <a
                          href={fullUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "none" }}
                        >
                          <Button
                            label="Acessar site"
                            rounded
                            icon="pi pi-external-link"
                            className="p-button-success mt-2 py-3 w-100"
                          />
                        </a>
                        <Button
                          label="Configurar"
                          rounded
                          icon="pi pi-cog"
                          className="p-button-secondary mt-2 py-3 w-100"
                          onClick={() =>
                            navigate(`/template/${template.id}`, {
                              state: {
                                enterprise_id: enterprise_id,
                                monthly_value: template.monthly_value,
                                subscription_value: template.subscription_value,
                                name: template.name,
                                landing_page_template_id: template.id,
                                signature_id: template.signatures.find(
                                  (sig) => sig.status !== 0
                                )?.id,
                              },
                            })
                          }
                        />
                      </>
                    ) : (
                      <>
                        <Button
                          label="Ver Preview"
                          rounded
                          icon="pi pi-eye"
                          className="p-button-secondary py-3 mt-2 w-100"
                          onClick={() =>
                            navigate(`/template/${template.id}/preview`, {
                              state: { enterprise_id: enterprise_id },
                            })
                          }
                        />
                        <PublishTemplateButton
                          formData={template}
                          templateConfig={template}
                          templateId={template.id}
                          enterprise_id={enterprise_id}
                          state={{
                            enterprise_id: enterprise_id,
                            monthly_value: template.monthly_value,
                            subscription_value: template.subscription_value,
                            name: template.name,
                            landing_page_template_id: template.id,
                          }}
                          monthlyValue={template.monthly_value}
                          subscriptionValue={template.subscription_value}
                          landingPageTemplateId={template.id}
                          templateName={displayName}
                          disabled={template.inUse}
                          label="Comprar template"
                          cards={cards}
                          visible={visible}
                          setCards={setCards}
                          cardState={cardState}
                          pixClient={pixClient}
                          pixDataQR={pixDataQR}
                          setVisible={setVisible}
                          setPixDataQR={setPixDataQR}
                          handleSubmitPayment={handleSubmitPayment}
                          baseDataForm={baseDataForm}
                          paymentMethod={paymentMethod}
                          loadingButton={loadingButton}
                          activeIndexModal={activeIndexModal}
                          handleInputFocus={handleInputFocus}
                          setPaymentMethod={setPaymentMethod}
                          creditCardClient={creditCardClient}
                          visiblePixPayment={visiblePixPayment}
                          handleInputChange={handleInputChange}
                          optionsInstallments={optionsInstallments}
                          setActiveIndexModal={setActiveIndexModal}
                          setCreditCardClient={setCreditCardClient}
                          setVisiblePixPayment={setVisiblePixPayment}
                          visiblePaymentMethods={visiblePaymentMethods}
                          visibleModalCreditCard={visibleModalCreditCard}
                          setVisiblePaymentMethods={setVisiblePaymentMethods}
                          setVisibleModalCreditCard={setVisibleModalCreditCard}
                        />
                      </>
                    )}
                  </div>
                </Card>
              </div>
            );
          })}
    </div>
  );
};

export default TemplateList;
